import { useNavigate, useParams } from 'react-router-dom';
import SmppboxContainer from './containers/SmppboxContainer';
import BearerboxContainer from './containers/BearerboxContainer';
import Typography from '@mui/material/Typography';
import { SERVERS_PATH } from '../../routes';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import Grid from '@mui/material/Grid';

const ServerDetailsView = () => {
  const { serverId } = useParams();
  const navigate = useNavigate();

  const handleGoToServerListView = () => {
    navigate(SERVERS_PATH);
  };

  if (!serverId) {
    return <>Server not found</>;
  }

  return (
    <>
      <Stack direction='row' spacing={1} alignItems='center' sx={{ pb: 2 }}>
        <IconButton aria-label='back to deployment view' onClick={handleGoToServerListView} >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'><strong>{serverId}</strong> server</Typography>
      </Stack>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h6'>Kannel boxes</Typography>
          <SmppboxContainer serverId={serverId} />
          <BearerboxContainer serverId={serverId} />
        </Grid>
      </Grid>
    </>
  );
};

export default ServerDetailsView;
